var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.quizStarted)?_c('section',{attrs:{"id":"quiz-section"}},[_c('ScrollDownCta',{attrs:{"quizStarted":_vm.quizStarted}}),_c('Question')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }